// Import controller interfaces
import {
    ISignUpController
} from '../Interfaces/ControllerInterfacesBarrel';
// Import api models.
import ApiController from './ApiController';
import {
    ErrorMessage,
    NewProducer,
    PossibleBusinessType,
    PossibleHeardThroughOption,
    PossibleMasterProducer
} from '@app/models/api';

export default class ProductionSignupController extends ApiController implements ISignUpController {

    private readonly controllerUrl: string = 'v2/signUp';

    public constructor() {
        super();
    }

    public async getPossibleBusinessTypes(): Promise<PossibleBusinessType[]> {
        let url: string = `${this.controllerUrl}/businessType`;

        try {
            let response: Response = await super.makeGetCall(url, undefined, undefined, false);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = 'Could not get possible business types.';
            }
            throw error;
        }
    }

    public async getPossibleProducerAgencies(): Promise<PossibleMasterProducer[]> {
        let url: string = `${this.controllerUrl}/possibleproducers`;

        try {
            let response: Response = await super.makeGetCall(url, undefined, undefined, false);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = 'Could not get possible producer agencies.';
            }
            throw error;
        }
    }

    public async getPossibleHeardThroughOptions(): Promise<PossibleHeardThroughOption[]> {
        let url: string = `${this.controllerUrl}/heardThrough`;

        try {
            let response: Response = await super.makeGetCall(url, undefined, undefined, false);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = 'Could not get possible heard through options.';
            }
            throw error;
        }
    }

    public async createProducer(newProducer: NewProducer): Promise<number> {
        let url: string = `${this.controllerUrl}/createproducer`;

        try {
            let response: Response = await super.makePostCall(url, newProducer, undefined, undefined, false);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = 'Could not create producer.';
            }
            throw error;
        }
    }
};